<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer005">
<p class="Ahead"><span epub:type="pagebreak" id="pagexi" title="xi"></span></p>
<p class="_toc" id="_idParaDest-3">Contents<a id="_idTextAnchor000"></a></p>
<p class="tx ParaOverride-1"><a href="#/."><span class="ital">Foreword</span></a><span class="ital"> by Cami Andersen  </span></p>
<p class="tx ParaOverride-2"><a href="#/."><span class="ital">Introduction</span></a> </p>
<p class="tx ParaOverride-3"><span class="med">Chapter 1:</span> <a href="#/.">Weird Herb</a> </p>
<p class="tx ParaOverride-4"><span class="med CharOverride-1">Chapter 2:</span> <a href="#/.">The Predator</a> </p>
<p class="tx ParaOverride-4"><span class="med CharOverride-1">Chapter 3:</span> <a href="#/.">Bones</a> </p>
<p class="tx ParaOverride-4"><span class="med CharOverride-1">Chapter 4:</span> <a href="#/.">Too Good to Be True</a> </p>
<p class="tx ParaOverride-4"><span class="med CharOverride-1">Chapter 5:</span> <a href="#/.">Haunted</a> </p>
<p class="tx ParaOverride-4"><span class="med CharOverride-1">Chapter 6:</span> <a href="#/.">Pursued</a> </p>
<p class="tx ParaOverride-4"><span class="med CharOverride-1">Chapter 7:</span> <a href="#/.">Attacked</a> </p>
<p class="tx ParaOverride-4"><span class="med CharOverride-1">Chapter 8:</span> <a href="#/.">Herb Did It</a> </p>
<p class="tx ParaOverride-4"><span class="med CharOverride-1">Chapter 9:</span> <a href="#/.">Boots on the Ground</a> </p>
<p class="tx ParaOverride-4"><span class="med CharOverride-1">Chapter 10:</span> <a href="#/.">Showdown</a> </p>
<p class="tx ParaOverride-4"><span class="med CharOverride-1">Chapter 11:</span> <a href="#/.">Into the Pool</a> </p>
<p class="tx ParaOverride-4"><span class="med CharOverride-1">Chapter 12:</span> <a href="#/.">Welcome Back</a> </p>
<p class="tx ParaOverride-4"><span class="med CharOverride-1">Chapter 13:</span> <a href="#/.">Mixing It Up</a> </p>
<p class="tx ParaOverride-4"><span class="med CharOverride-1">Chapter 14:</span> <a href="#/.">A Truly Sick Man</a> </p>
<p class="tx ParaOverride-4"><span class="med CharOverride-1">Chapter 15:</span> <a href="#/.">The One That Got Away</a> </p>
<p class="tx ParaOverride-4"><span class="med CharOverride-1">Chapter 16:</span> <a href="#/.">Get Away from There</a> </p>
<p class="tx ParaOverride-4"><span class="med CharOverride-1">Chapter 17:</span> <a href="#/.">Stay Away</a> </p>
<p class="tx ParaOverride-3"><a href="#/HFHF19#_idParaDest-24"><span class="ital">Conclusion: Making Sense of It All</span></a><span class="ital"> </span></p>
<p class="tx ParaOverride-2"><a href="#/HFHF20#_idParaDest-25"><span class="ital">Bibliography</span></a> </p>
<p class="tx ParaOverride-2"><a href="#/HFHF20a#_idParaDest-26"><span class="ital">Acknowledgments</span></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?2d63ad6a